module.exports = __webpack_public_path__ + "static/media/defaultLogo.14d3224c.png";